import axios from 'axios'
import { useContext, useState } from 'react'
import { ConfigurationContext } from '../../context api/Configuration/ConfigurationContext'
import { EmployeeContext } from '../../context api/Employee/EmployeeContext'
import { UserContext } from '../../context api/UserContext'
import { formTokenHeader } from '../../lib/HeaderHelper'
import { toastMessage } from '../../shared/AlertPopup'
import { API } from '../../shared/API'
import { error, success } from '../../shared/constants'

export const useEmployee = () => {
  const user = useContext(UserContext)
  const token = user && user.token
  const header = formTokenHeader(token)
  const [attendance, setEmployee] = useState(false)
  const { addNewEmployee, editNewEmployee, deleteNewEmployee, getNewEmployees } = useContext(EmployeeContext)
  const [loading, setLoading] = useState(false)

  const getAllEmployee = async (dto) => {
    setLoading(true)
    axios
      .get(API.GET_ALL_EMPLOYEE, dto, header)
      .then(({ status, data }) => {
        //console.log('DATA : ', data)
        setLoading(false)
        if (status !== 200) {
          return toastMessage('Something Went Wrong !', error)
        }
        getNewEmployees(data.data)
        // setEmployees(data.data)
      })
      .catch((err) => {
        //console.log(err)
        setLoading(false)
        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error || (err.response.data.errors.length && err.response.data.errors[0].msg), error)
        }
      })
  }
  const getEmployee = async (dto) => {
    setLoading(true)
    axios
      .post(API.GET_EMPLOYEE, dto, header)
      .then(({ status, data }) => {
        setLoading(false)
        //console.log('DATA : ', data)
        if (status !== 200) {
          return toastMessage('Something Went Wrong !', error)
        }
        setEmployee(data.data)
        // setEmployees(data.data)
      })
      .catch((err) => {
        //console.log(err)
        setLoading(false)
        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error || (err.response.data.errors.length && err.response.data.errors[0].msg), error)
        }
      })
  }

  const deleteEmployee = (dto, setSelected) => {
    setLoading(true)
    axios
      .post(API.DELETE_EMPLOYEE, dto, header)
      .then(({ status, data }) => {
        setLoading(false)
        //console.log('DATA : ', data)
        if (status !== 200) {
          return toastMessage('Something Went Wrong !', error)
        }
        toastMessage('Employee Deleted Successfully', success)
        deleteNewEmployee(dto.employeeId)
        setSelected([])
        // addNewEmployee(data.data)
      })
      .catch((err) => {
        setLoading(false)
        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error || (err.response.data.errors.length && err.response.data.errors[0].msg), error)
        }
      })
  }
  const deleteManyEmployee = (dto, setSelected) => {
    setLoading(true)
    axios
      .post(API.DELETE_MANY_EMPLOYEE, dto, header)
      .then(({ status, data }) => {
        setLoading(false)
        //console.log('DATA : ', data)
        if (status !== 200) {
          return toastMessage('Something Went Wrong !', error)
        }
        toastMessage(`${dto.employeeId.length} Employee Deleted Successfully`, success)

        dto.employeeId.map((item) => deleteNewEmployee(item))
        setSelected([])
      })
      .catch((err) => {
        setLoading(false)
        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error || (err.response.data.errors.length && err.response.data.errors[0].msg), error)
        }
      })
  }

  return {
    getAllEmployee,
    deleteEmployee,
    getEmployee,
    attendance,
    deleteManyEmployee,
    loading,
  }
}
